import { Link } from "react-router-dom";
import ImageGallery from "../components/ImageGallery";
import getAlbumImages from "../components/getAlbumImages";
import cursor from "../assets/img/cursor.png";

const galleryImages = getAlbumImages("IH8FW");

const IH8FW = () => {
  return (
    <div>
      <Link to="/Fashion">
        <img id="menu1" src={cursor} alt="menu" title="Home" />
      </Link>

      <ImageGallery images={galleryImages} />
    </div>
  );
};

export default IH8FW;
